import { SchedulerDateNavigationSection } from '@lp/features/Scheduler/components';
import { WorkdaySyncData } from '@lp/features/Scheduler/types';
import { SOrganGroup } from '@lp/features/Scheduler/SchedulerSurgeons/types';
import { SResourcesWithShifts } from '@/api/apis/resources/schedule';
import { SSchedulerFiltersSection } from './components';

type SSchedulerControlRowProps = {
  readonly?: boolean;
  organGroup: SOrganGroup;
  selectedDate: Date;
  shiftsData: SResourcesWithShifts;
  workdayData?: WorkdaySyncData;
  onDateChange: (date: Date) => void;
  isReservationsView: boolean;
  setIsReservationsView: (value: boolean) => void;
};

export const SSchedulerControlRow = ({
  readonly,
  organGroup,
  selectedDate,
  shiftsData,
  workdayData,
  onDateChange,
  isReservationsView,
  setIsReservationsView,
}: SSchedulerControlRowProps) => {
  return (
    <div className="flex items-center gap-2 justify-between grow">
      <SchedulerDateNavigationSection selectedDate={selectedDate} onDateChange={onDateChange} />
      <SSchedulerFiltersSection
        organGroup={organGroup}
        readonly={readonly}
        shiftsData={shiftsData}
        workdayData={workdayData}
        isReservationsView={isReservationsView}
        setIsReservationsView={setIsReservationsView}
      />
    </div>
  );
};
